// src/services/trainer.service.js
import { baseApi } from "./base.api";
import { API_CONFIG } from "../config/api.config";

class TrainerService {
  createTrainer(data) {
    return baseApi.post(API_CONFIG.ENDPOINTS.TRAINER.CREATE, data);
  }

  getTrainers(params = {}) {
    let url = API_CONFIG.ENDPOINTS.TRAINER.SHOW;
    if (params && Object.keys(params).length > 0) {
      const qs = Object.keys(params)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join("&");
      url = `${url}?${qs}`;
    }
    return baseApi.get(url);
  }

  async getTrainerById(id) {
    const response = await baseApi.get(
      API_CONFIG.ENDPOINTS.TRAINER.SEARCH_BY_ID(id),
    );
    // Return both trainer and user data
    return {
      trainer: response?.trainer || null,
      user: response?.user || null,
    };
  }

  updateTrainer(id, data) {
    return baseApi.put(API_CONFIG.ENDPOINTS.TRAINER.UPDATE(id), data);
  }

  deleteTrainer(id) {
    return baseApi.delete(API_CONFIG.ENDPOINTS.TRAINER.DELETE(id));
  }

  searchByName(payload) {
    return baseApi.post(API_CONFIG.ENDPOINTS.TRAINER.SEARCH_BY_NAME, payload);
  }

  getTrainersForPrint(params = {}) {
    let url = API_CONFIG.ENDPOINTS.TRAINER.PRINT;
    if (params && Object.keys(params).length > 0) {
      const qs = Object.keys(params)
        .filter(
          (k) =>
            params[k] !== undefined && params[k] !== null && params[k] !== "",
        )
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join("&");
      if (qs) {
        url = `${url}?${qs}`;
      }
    }
    return baseApi.get(url);
  }

  checkUsernameAvailability(username) {
    return baseApi.get(`/trainer/check-username?username=${encodeURIComponent(username)}`);
  }
}

export const trainerService = new TrainerService();
